import * as React from "react";
const SvgFiRrSigma = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18 24H4.872a2.84 2.84 0 0 1-2.622-1.705 2.83 2.83 0 0 1 .495-3.087C2.777 19.172 11.434 12 11.434 12S2.778 4.828 2.745 4.792a2.83 2.83 0 0 1-.495-3.087A2.84 2.84 0 0 1 4.872 0H18c2.206 0 4 1.794 4 4v1a1 1 0 1 1-2 0V4c0-1.103-.896-2-2-2H4.872a.86.86 0 0 0-.794.516.86.86 0 0 0 .111.889l9.449 7.825a1 1 0 0 1 0 1.54l-9.449 7.825a.85.85 0 0 0-.11.889c.053.121.27.516.793.516H18c1.104 0 2-.897 2-2v-1a1 1 0 1 1 2 0v1c0 2.206-1.794 4-4 4"
    />
  </svg>
);
export default SvgFiRrSigma;
